import TableWrap from 'ui/table/TableWrap'
import TableScrollContainer from 'ui/table/TableScrollContainer'
import { Table as InnerTable } from '@morningtrain/react-columns'

export default function Table ({
  tableProps = {},
  striped = false,
  children,
  ...forwardProps
}) {
  return (
    <TableWrap className={striped ? 'striped' : ''}>
      <TableScrollContainer>
        <InnerTable {...tableProps} {...forwardProps}>
          {children}
        </InnerTable>
      </TableScrollContainer>
    </TableWrap>
  )
}
